var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"messRate"},[_c('el-slider',{on:{"change":_vm.change},model:{value:(_vm.rateValue_),callback:function ($$v) {_vm.rateValue_=$$v},expression:"rateValue_"}}),_c('div',[_vm._v(_vm._s(_vm.rateValue_)+"分")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }